function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bookmark"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m18 22c-.106 0-.213-.017-.316-.051l-5.684-1.895-5.684 1.895c-.305.1-.64.051-.901-.138-.261-.188-.415-.49-.415-.811v-16c0-1.654 1.346-3 3-3h8c1.654 0 3 1.346 3 3v16c0 .321-.154.623-.416.811-.172.125-.377.189-.584.189zm-6-4c.107 0 .213.017.316.051l4.684 1.562v-14.613c0-.551-.449-1-1-1h-8c-.551 0-1 .449-1 1v14.613l4.684-1.562c.103-.034.209-.051.316-.051z"
})));

var Svg018Bookmark = function Svg018Bookmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg018Bookmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/018-bookmark.19cfcab9.svg";
export { ForwardRef as ReactComponent };